{
  "__localization_test_string": "لقد وصلت إلى الحد الأقصى لعدد الزيارات لهذا المزود لـ {{time_period}}. يمكنك بعد ذلك زيارة هذا المزود بدءًا من {{start_date}}.",
  "app_name": "Plentiful",
  "app_button_ok": "نعم",
  "app_button_cancel": "يلغي",
  "app_button_yes": "نعم",
  "app_button_no": "لا",
  "app_button_confirm": "يتأكد",
  "app_button_try_again": "حاول مرة أخري",
  "rate_the_app": "قيّم Plentiful",
  "app_textview_somethingwentwrong": "حدث خطأ ما!\nيُرجى المحاولة مرة أخرى",
  "app_button_logout": "تسجيل خروج",
  "app_today": "اليوم",
  "app_dialog_clarify_prompt": "هل أنت واثق؟",
  "app_personal_edittext_phone": "رقم الهاتف",
  "app_personal_edittext_dob": "تاريخ الميلاد (اختياري)",
  "app_personal_edittext_firstname": "الاسم الأول",
  "app_personal_edittext_lastname": "الكنية",
  "app_personal_edittext_zipcode": "رمز بريدي",
  "app_pantrykind_food": "مخزن الطعام",
  "app_servicekind_reservations": "الحجز",
  "app_servicekind_line": "خط",
  "distribution_schedule": "جدول التوزيع",
  "service_type_no_digital_options": "طابور فقط",
  "service_type_reservation_inline": "الحجوزات",
  "service_type_allows_pre_registration": "يسمح بالتسجيل المسبق",
  "app_locationnotavailable": "الموقع غير متوفر",
  "app_generalerror": "خطأ",
  "app_dialog_loading": "تحميل. ارجوك انتظر…",
  "app_dialog_sms_code_title": "رمز الرسائل القصيرة",
  "app_dialog_sms_code_button_send_new_code": "إرسال رمز جديد",
  "app_release_id": "معرف إصدار التطبيق",
  "sms_disclaimer": "قد تطبق رسوم الرسائل والبيانات. أرسل STOP لإلغاء الاشتراك.",
  "fragment_registration_language_textview_title": "حدد اللغة المفضلة لديك للبدء",
  "fragment_registration_language_button_next": "التالي",
  "fragment_registration_family_textview_title": "أخبرنا عن منزلك",
  "fragment_registration_family_textview_adults": "({{senior_age_threshold_minus_one}}-18) عدد البالغين",
  "fragment_registration_family_textview_children": "عدد الأطفال (أقل من 18 عامًا)",
  "fragment_registration_family_textview_seniors": "(+{{senior_age_threshold}}) عدد كبار السن",
  "fragment_registration_family_textview_notetitle": "ملحوظة:",
  "fragment_registration_family_textview_notecontent": "ساعدنا في خدمتك بشكل أفضل من خلال تزويدنا بتفاصيل عن أسرتك. ملاحظة: لا تُدرج اسمك ضمن عدد أفراد الأسرة المذكورين أعلاه.",
  "fragment_registration_family_button_back": "خلف",
  "fragment_registration_family_button_next": "التالي",
  "fragment_registration_personal_textview_title": "مرحباً بكم في ملفكم الشخصي الوفير",
  "fragment_registration_personal_button_back": "خلف",
  "fragment_registration_personal_button_finish": "ينهي",
  "fragment_main_tabitem_pantrymap": "خريطة",
  "fragment_main_tabitem_pantrylist": "قائمة",
  "fragment_main_bottombar_pantries": "من أصل",
  "fragment_main_bottombar_visits": "الزيارات",
  "fragment_main_bottombar_messages": "رسائل",
  "fragment_main_bottombar_profile": "حساب تعريفي",
  "cell_pantry_short_visit_date": "انت ذاهب",
  "fragment_pantrydetail_button_changetime": "غير الوقت",
  "fragment_pantrydetail_textview_amenities": "وسائل الراحة",
  "fragment_pantrydetail_textview_conditions": "الظروف",
  "fragment_pantrydetail_textview_notes": "ملاحظات مخزن",
  "fragment_pantrydetail_edittext_message": "رسالة…",
  "fragment_pantrydetail_button_createreservation": "جدولة الزيارة",
  "fragment_pantrydetail_button_schedulevisit": "جدول الزيارة",
  "dialog_visittime_textview_nodatesavailable": "لا التواريخ المتاحة",
  "fragment_visitlist_textview_title": "الزيارات",
  "fragment_visitlist_textview_zero": "هذا هو المكان الذي يمكنك فيه إدارة أوقات الخدمات القادمة. العثور على مخزن لجدولة زيارة!",
  "fragment_messagethreadlist_textview_title": "رسائل",
  "fragment_messagethreadlist_textview_zero": "لا توجد تحديثات حتى الآن!\nللاشتراك في التحديثات، انتقل إلى صفحة تفاصيل مخزنك المفضل وقم بتفعيل \"الحصول على التحديثات من هذا المخزن\" الموجود في أسفل الصفحة.",
  "fragment_profile_textview_title": "حساب تعريفي",
  "fragment_profile_button_savechanges": "حفظ التغييرات",
  "fragment_profile_textview_personaldetails": "تفاصيل شخصية",
  "fragment_profile_textview_language": "لغة",
  "fragment_profile_textview_notifications": "إشعارات",
  "fragment_profile_switch_receivenotifications": "إشعارات الدفع",
  "receive_notifications_helper": "تلقي التنبيهات على جهازك",
  "fragment_profile_textview_servicedetails": "تفاصيل الخدمة",
  "fragment_profile_switch_pickupfood": "أطلب من شخص آخر أن يلتقط طعامي",
  "fragment_profile_edittext_pickupname": "ممثل الالتقاط الاسم الأول والأخير",
  "fragment_profile_edittext_pickupphone": "رقم هاتف مندوب الاستلام",
  "textview_baby_supplies": "كم عدد الأطفال الذين تحتاجهم مستلزمات أطفال (حفاضات ، مناديل ، حليب صناعي)",
  "fragment_profile_textview_emergencycontact": "الاتصال بالطوارىء",
  "fragment_profile_edittext_emergencyname": "جهة اتصال الطوارئ الاسم الأول والأخير",
  "fragment_profile_edittext_emergencyphone": "هاتف الاتصال في حالات الطوارئ",
  "aiq_validation_error_regex_telephone_us": "رقم الهاتف بتنسيق غير صحيح",
  "fragment_profile_textview_changepersonalinfo": "يمكن تحديث هذه المعلومات في أي مخزن غذائي وفير.",
  "fragment_profile_edittext_feedback": "ردود الفعل…",
  "fragment_profile_toast_feedbacksent": "أرسلت ردود الفعل",
  "baby_supplies": "لوازم الأطفال",
  "household_size": "حجم الأسرة",
  "food_pickup": "بيك اب الغذاء",
  "emergency_contact": "الاتصال بالطوارىء",
  "dialog_app_update_title": "التحديث متاح",
  "dialog_app_update_message": "الإصدار التالي من التطبيق متوفر في متجر Google Play!",
  "dialog_app_update_button_openplaystore": "افتح Play Store.",
  "app_invalid_error": "غير صالح",
  "no_pantries_available": "لم يتم العثور على نتائج. جرّب البحث باستخدام اسم مخزن مختلف، أو امسح مربع البحث، ثمّ حرّك الخريطة أو كبّرها لاستكشاف المناطق التي تضمّ مخازن Plentiful.",
  "visit_served": "خدم",
  "visit_not_served": "لم يخدم",
  "visit_no_show": "أنت لم تظهر",
  "visit_group": "أنت في المجموعة {{group_number}}، تفضل {{time}}",
  "visit_pre_registered": "لقد قمت بالتسجيل المسبق، انضم إلى الخط الفاصل بين {{from_time}} - {{end_time}}",
  "pick_visit_time": "اختيار الزيارة الزمنية",
  "received_service_on": "لقد زرت على",
  "service_starts_at": "تبدأ الخدمة في",
  "cancel_visit": "إلغاء الزيارة",
  "confirm_cancel_visit": "هل أنت متأكد أنك تريد إلغاء زيارتك؟",
  "yes_cancel": "نعم، إلغاء",
  "send": "يرسل",
  "reservations_available": "أبلغني عندما أتمكن من جدولة زيارة",
  "service_notification_error": "حدث خطأ أثناء تحديث إعداد الإشعارات الخاص بك. يرجى المحاولة مجدداً. لا تزال تواجه مشكلة؟ اضغط على الملف الشخصي ثم نحن هنا للمساعدة للتواصل مع الدعم.",
  "report_location_issue": "الإبلاغ عن مشكلة في هذا الموقع",
  "registration_intro": "أهلاً بكم في بلنتيفول! نحن هنا لمساعدتكم في العثور على مخازن الطعام القريبة منكم.",
  "app_personal_edittext_enter_phone": "أدخل رقم هاتفك",
  "code_sent_to": "تم إرسال رمز تسجيل الدخول عبر الرسائل القصيرة إلى",
  "account_created": "تم إنشاء الحساب",
  "get_started": "دعونا نبدأ!",
  "additional_details": "معلومات إضافية",
  "your_qr_code": "الخاص بك prenti-pass",
  "id_number": "رقم الهوية",
  "personal_details_extra": "المعلومات الشخصية والتفضيلات",
  "settings": "إعدادات",
  "settings_extra": "إعدادات اللغة والإخطار",
  "not_verified": "لم تحقق بعد",
  "must_be_reverified_by": "يجب التبجيل من قبل",
  "last_verified_on": "آخر مرة تم التحقق منها",
  "at": "في",
  "no_visit_options_available": "لا توجد خيارات زيارة متاحة لك في الوقت الحالي. يرجى التحقق من شروط المخزن أو الاتصال بالمخزن.",
  "need_help": "تحتاج مساعدة؟",
  "email": "بريد الالكتروني",
  "terms_conditions": "اتفاقية المستخدم النهائي",
  "privacy_policy": "سياسة الخصوصية",
  "updates": "تحديثات",
  "family_details": "تفاصيل المنزل",
  "welcome_to_plentiful": "مرحبا بكم في وفيرة!",
  "enter_email_phone": "يتيح لك التسجيل إجراء حجوزات وتلقي تحديثات عن مخازن الطعام التي تزورها.\nإذا كنت مسجلاً في مخزن طعام، فاستخدم نفس رقم الهاتف أو البريد الإلكتروني. \nهل تحتاج إلى مساعدة؟ تواصل معنا على support@plentiful.org",
  "email_or_phone": "رقم الهاتف المحمول أو عنوان البريد الإلكتروني",
  "email_address": "عنوان البريد الإلكتروني",
  "enter_email": "أدخل بريدك الإلكتروني",
  "address": "عنوان",
  "email_invalid": "عنوان البريد الإلكتروني غير صالح",
  "no_sms_enabled_phone": "رقم الهاتف لا يمكنه استقبال الرسائل النصية",
  "verification_email_sent": "البريد الإلكتروني التحقق المرسلة!",
  "check_verification_email": "تحقق من بريدك الإلكتروني وانقر على الزر الموجود بالداخل للتحقق من حسابك",
  "email_verification_sent": "لقد أرسلنا لك رسالة بالبريد الإلكتروني. الرجاء النقر فوق الزر الموجود في البريد الإلكتروني للتحقق من عنوان بريدك الإلكتروني.",
  "email_address_purpose": "لتلقي تذكيرات الزيارة والتحديثات الهامة من Plentiful",
  "sign_up": "اشتراك",
  "sign_in": "تسجيل الدخول",
  "continue": "يكمل",
  "create_password": "إنشاء كلمة المرور",
  "enter_password": "الرجاء إدخال كلمة المرور الخاصة بك لتسجيل الدخول",
  "password_info_box": "إذا نسيت كلمة المرور الخاصة بك أو كنت مسجلاً في مخزن دون تعيين كلمة مرور، فيرجى استخدام الخيارات أدناه لتسجيل الدخول باستخدام السحر أو لإعادة تعيين كلمة المرور الخاصة بك.",
  "reset_password": "إعادة تعيين كلمة المرور",
  "password": "كلمه السر",
  "eight_characters": "8 أحرف على الأقل",
  "one_special_character": "شخصية خاصة على الأقل",
  "one_number": "رقم واحد على الأقل",
  "submit": "إرسال",
  "send_magic_link": "أرسل رابط سحري",
  "magic_link_sent": "رابط سحري في طريقه إلى صندوق الوارد الخاص بك.",
  "confirm_magic_link_login": "تأكيد تسجيل الدخول إلى الرابط السحري",
  "sign_in_another_way": "تسجيل الدخول بطريقة أخرى",
  "enter_phone": "يرجى إدخال رقم الهاتف الخاص بك",
  "skip": "يتخطى",
  "optional": "اختياري",
  "enter_activation_code": "الرجاء إدخال رمز تسجيل الدخول الخاص بك",
  "activation_code": "رمز تسجيل الدخول",
  "accept_eula": "لقد قرأت وأوافق على شروط الاستخدام والخصوصية",
  "email_verified": "التحقق من البريد الإلكتروني",
  "email_verified_details": "تم التحقق من عنوان بريدك الإلكتروني الآن.",
  "do_not_ask_again": "لا تسأل مجددا.",
  "email_in_use": "لدينا بالفعل حساب مرتبط بهذا البريد الإلكتروني. يرجى استخدام بريد إلكتروني مختلف",
  "reset_password_text": "الرجاء إدخال بريدك الإلكتروني لإعادة تعيين كلمة المرور الخاصة بك",
  "reset_password_sent": "إعادة تعيين كلمة المرور البريد الإلكتروني المرسلة!",
  "reset_password_sent_text": "إذا كان لدينا حساب في ملف ل {{email}}، فقد أرسلنا رابط لإعادة تعيين كلمة المرور الخاصة بك،",
  "dob_required": "تاريخ الولادة",
  "please_verify": "يرجى التحقق من الهاتف أو البريد الإلكتروني في ملف التعريف الخاص بك",
  "open_profile": "فتح الملف الشخصي",
  "send_another_verification_email": "إرسال البريد الإلكتروني التحقق آخر",
  "need_to_change_email": "إذا كنت بحاجة إلى تغيير عنوان بريدك الإلكتروني، يرجى الاتصال بـ support@plentifulapp.com.",
  "need_to_change_email_or_phone": "إذا كنت بحاجة إلى تغيير عنوان بريدك الإلكتروني أو رقم هاتفك، فيرجى الاتصال بـ support@plentifulapp.com.",
  "need_to_change_phone": "إذا كنت بحاجة إلى تغيير رقم هاتفك، فيرجى الاتصال ب Support@plentifulapp.com أو زيارة مخزن.",
  "email_subscription": "اشتراك البريد الإلكتروني",
  "email_subscribed": "البريد الإلكتروني المشترك",
  "email_unsubscribed": "البريد الإلكتروني إلغاء الاشتراك",
  "email_subscribed_text": "لقد اشتركت الآن {{email}} إلى رسائل البريد الإلكتروني الوفيرة",
  "email_unsubscribed_text": "لديك الآن إلغاء تحديد {{email}} من رسائل البريد الإلكتروني الوفيرة",
  "here_to_subscribe": "انقر هنا للاشتراك في رسائل البريد الإلكتروني الوفيرة",
  "here_to_unsubscribe": "انقر هنا لإلغاء الاشتراك من رسائل البريد الإلكتروني الوفيرة",
  "unsubscribe": "إلغاء الاشتراك",
  "subscribe": "يشترك",
  "open_profile_text": "انقر هنا للذهاب إلى ملف التعريف الخاص بك",
  "sign_in_text": "اضغط هنا لتسجيل الدخول",
  "phone_assigned": "رقم الهاتف هذا قيد الاستخدام بالفعل. أدخل رقم هاتف آخر أو العودة وتسجيل الدخول باستخدام رقم الهاتف هذا بدلا من ذلك.",
  "email_subscribe": "تحديثات البريد الإلكتروني",
  "email_subscribe_helper": "رسائل من المخازن التي تزورها ومن Plentiful",
  "message_preferences": "تفضيلات الرسائل",
  "message_preferences_description": "كيف تريد تلقي تذكيرات الزيارة والتحديثات؟",
  "message_method_option_0": "البريد الإلكتروني وإشعارات التطبيق",
  "message_method_option_1": "تفضيل SMS",
  "message_method_helper_add_phone": "أضف رقم هاتفك لتلقي رسائل SMS",
  "message_method_helper_sms_opt_in": "أرسل 'START' إلى PANTRY (726-879) للاشتراك مجدداً في SMS",
  "message_method_helper_add_email": "أضف بريدك الإلكتروني لتلقي رسائل البريد",
  "message_method_helper_email_unsub": "لقد ألغيت اشتراكك في رسائل البريد الإلكتروني. قم بتحديث تفضيلات البريد لتلقيها.",
  "message_method_helper_add_push": "قم بتنزيل تطبيق الهاتف لتلقي الإشعارات",
  "message_method_helper_enable_push": "قم بتفعيل الإشعارات في إعدادات جهازك لتلقي إشعارات الدفع",
  "password_error": "كلمة مرور خاطئة. حاول مرة أخرى، إعادة تعيين كلمة المرور الخاصة بك، أو تسجيل الدخول بطريقة أخرى",
  "action_required": "الإجراء مطلوب",
  "otp_error": "لا يمكن التحقق من الكود",
  "show_more": "أظهر المزيد",
  "pre_registration": "تسجيل",
  "show_less": "عرض أقل",
  "reschedule": "إعادة جدولة",
  "view_pantry": "عرض تفاصيل المخزن",
  "next_service_on": "الخدمة التالية في",
  "add_birthday": "أضف تاريخ ميلادك لفتح بطاقة Plenti-Pass الخاصة بك",
  "birthday_required": "يمكن استخدام هذه البطاقة لإجراء تسجيل سريع وسهل في المخازن.",
  "missed_reservation_on": "فاتك حجزك على",
  "delete_account": "حذف الحساب",
  "delete_explain": "هل انت متأكد انك تريد حذف حسابك؟ سيؤدي هذا إلى إلغاء جميع زيارات المخزن القادمة وحذف حسابك. ستحتاج إلى التسجيل مرة أخرى لاستخدام Plentiful.",
  "yes_delete": "نعم حذف",
  "no_cancel": "لا، إلغاء",
  "select_visit_reschedule": "حدد الزيارة التي تريد إعادة جدولةها",
  "select_visit_cancel": "حدد الزيارة التي تريد إلغاؤها",
  "search_pantries": "البحث عن المخازن",
  "please_sign_in_or_up": "سوف تحتاج إلى حساب وفير للمتابعة. وفيرة مجانية تماما للاستخدام.",
  "sign_in_or_up": "تسجيل الدخول أو التسجيل للمتابعة",
  "country_of_birth_option_AF": "أفغانستان",
  "country_of_birth_option_AX": "جزر آلاند",
  "country_of_birth_option_AL": "ألبانيا",
  "country_of_birth_option_DZ": "الجزائر",
  "country_of_birth_option_AS": "ساموا الأمريكية",
  "country_of_birth_option_AD": "أندورا",
  "country_of_birth_option_AO": "أنغولا",
  "country_of_birth_option_AI": "أنغيلا",
  "country_of_birth_option_AQ": "أنتاركتيكا",
  "country_of_birth_option_AG": "أنتيغوا وبربودا",
  "country_of_birth_option_AR": "الأرجنتين",
  "country_of_birth_option_AM": "أرمينيا",
  "country_of_birth_option_AW": "أروبا",
  "country_of_birth_option_AU": "أستراليا",
  "country_of_birth_option_AT": "النمسا",
  "country_of_birth_option_AZ": "أذربيجان",
  "country_of_birth_option_BS": "جزر البهاما",
  "country_of_birth_option_BH": "البحرين",
  "country_of_birth_option_BD": "بنغلاديش",
  "country_of_birth_option_BB": "بربادوس",
  "country_of_birth_option_BY": "بيلاروسيا",
  "country_of_birth_option_BE": "بلجيكا",
  "country_of_birth_option_BZ": "بليز",
  "country_of_birth_option_BJ": "بنين",
  "country_of_birth_option_BM": "برمودا",
  "country_of_birth_option_BT": "بوتان",
  "country_of_birth_option_BO": "بوليفيا",
  "country_of_birth_option_BA": "البوسنة والهرسك",
  "country_of_birth_option_BW": "بوتسوانا",
  "country_of_birth_option_BV": "جزيرة بوجيت",
  "country_of_birth_option_BR": "البرازيل",
  "country_of_birth_option_IO": "إقليم المحيط البريطاني الهندي",
  "country_of_birth_option_BN": "بروناي دار السلام",
  "country_of_birth_option_BG": "بلغاريا",
  "country_of_birth_option_BF": "بوركينا فاسو",
  "country_of_birth_option_BI": "بوروندي",
  "country_of_birth_option_KH": "كمبوديا",
  "country_of_birth_option_CM": "الكاميرون",
  "country_of_birth_option_CA": "كندا",
  "country_of_birth_option_CV": "الرأس الأخضر",
  "country_of_birth_option_KY": "جزر كايمان",
  "country_of_birth_option_CF": "جمهورية افريقيا الوسطى",
  "country_of_birth_option_TD": "تشاد",
  "country_of_birth_option_CL": "شيلي",
  "country_of_birth_option_CN": "الصين",
  "country_of_birth_option_CX": "جزيرة الكريسماس",
  "country_of_birth_option_CC": "جزر كوكوس (كيلينغ)",
  "country_of_birth_option_CO": "كولومبيا",
  "country_of_birth_option_KM": "جزر القمر",
  "country_of_birth_option_CG": "كونغو",
  "country_of_birth_option_CD": "الكونغو، الجمهورية الديمقراطية",
  "country_of_birth_option_CK": "جزر كوك",
  "country_of_birth_option_CR": "كوستا ريكا",
  "country_of_birth_option_CI": "كوت ديفاير",
  "country_of_birth_option_HR": "كرواتيا",
  "country_of_birth_option_CU": "كوبا",
  "country_of_birth_option_CY": "قبرص",
  "country_of_birth_option_CZ": "الجمهورية التشيكية",
  "country_of_birth_option_DK": "الدنمارك",
  "country_of_birth_option_DJ": "جيبوتي",
  "country_of_birth_option_DM": "دومينيكا",
  "country_of_birth_option_DO": "جمهورية الدومينيكان",
  "country_of_birth_option_EC": "الإكوادور",
  "country_of_birth_option_EG": "مصر",
  "country_of_birth_option_SV": "السلفادور",
  "country_of_birth_option_GQ": "غينيا الإستوائية",
  "country_of_birth_option_ER": "إريتريا",
  "country_of_birth_option_EE": "إستونيا",
  "country_of_birth_option_ET": "أثيوبيا",
  "country_of_birth_option_FK": "جزر فوكلاند (مالفيناس)",
  "country_of_birth_option_FO": "جزر فاروس",
  "country_of_birth_option_FJ": "فيجي",
  "country_of_birth_option_FI": "فنلندا",
  "country_of_birth_option_FR": "فرنسا",
  "country_of_birth_option_GF": "غيانا الفرنسية",
  "country_of_birth_option_PF": "بولينيزيا الفرنسية",
  "country_of_birth_option_TF": "المناطق الجنوبية لفرنسا",
  "country_of_birth_option_GA": "غابون",
  "country_of_birth_option_GM": "غامبيا",
  "country_of_birth_option_GE": "جورجيا",
  "country_of_birth_option_DE": "ألمانيا",
  "country_of_birth_option_GH": "غانا",
  "country_of_birth_option_GI": "جبل طارق",
  "country_of_birth_option_GR": "اليونان",
  "country_of_birth_option_GL": "الأرض الخضراء",
  "country_of_birth_option_GD": "غرينادا",
  "country_of_birth_option_GP": "غواديلوب",
  "country_of_birth_option_GU": "غوام",
  "country_of_birth_option_GT": "غواتيمالا",
  "country_of_birth_option_GG": "غيرنسي",
  "country_of_birth_option_GN": "غينيا",
  "country_of_birth_option_GW": "غينيا بيساو",
  "country_of_birth_option_GY": "غيانا",
  "country_of_birth_option_HT": "هايتي",
  "country_of_birth_option_HM": "قلب الجزيرة وجزر ماكدونالز",
  "country_of_birth_option_VA": "الكرسي الرسولي (دولة مدينة الفاتيكان)",
  "country_of_birth_option_HN": "هندوراس",
  "country_of_birth_option_HK": "هونج كونج",
  "country_of_birth_option_HU": "هنغاريا",
  "country_of_birth_option_IS": "أيسلندا",
  "country_of_birth_option_IN": "الهند",
  "country_of_birth_option_ID": "إندونيسيا",
  "country_of_birth_option_IR": "إيران، جمهورية إسلامية",
  "country_of_birth_option_IQ": "العراق",
  "country_of_birth_option_IE": "أيرلندا",
  "country_of_birth_option_IM": "جزيرة آيل أوف مان",
  "country_of_birth_option_IL": "إسرائيل",
  "country_of_birth_option_IT": "إيطاليا",
  "country_of_birth_option_JM": "جامايكا",
  "country_of_birth_option_JP": "اليابان",
  "country_of_birth_option_JE": "جيرسي",
  "country_of_birth_option_JO": "الأردن",
  "country_of_birth_option_KZ": "كازاخستان",
  "country_of_birth_option_KE": "كينيا",
  "country_of_birth_option_KI": "كيريباتي",
  "country_of_birth_option_KP": "كوريا، الجمهورية الشعبية الديمقراطية",
  "country_of_birth_option_KR": "جمهورية كوريا",
  "country_of_birth_option_KW": "الكويت",
  "country_of_birth_option_KG": "قيرغيزستان",
  "country_of_birth_option_LA": "جمهورية لاو الديمقراطية",
  "country_of_birth_option_LV": "لاتفيا",
  "country_of_birth_option_LB": "لبنان",
  "country_of_birth_option_LS": "ليسوتو",
  "country_of_birth_option_LR": "ليبيريا",
  "country_of_birth_option_LY": "الجماهيرية العربية الليبية",
  "country_of_birth_option_LI": "ليختنشتاين",
  "country_of_birth_option_LT": "ليتوانيا",
  "country_of_birth_option_LU": "لوكسمبورغ",
  "country_of_birth_option_MO": "ماكاو",
  "country_of_birth_option_MK": "مقدونيا، الجمهورية اليوغوسلافية السابقة",
  "country_of_birth_option_MG": "مدغشقر",
  "country_of_birth_option_MW": "ملاوي",
  "country_of_birth_option_MY": "ماليزيا",
  "country_of_birth_option_MV": "جزر المالديف",
  "country_of_birth_option_ML": "مالي",
  "country_of_birth_option_MT": "مالطا",
  "country_of_birth_option_MH": "جزر مارشال",
  "country_of_birth_option_MQ": "مارتينيك",
  "country_of_birth_option_MR": "موريتانيا",
  "country_of_birth_option_MU": "موريشيوس",
  "country_of_birth_option_YT": "مايوت",
  "country_of_birth_option_MX": "المكسيك",
  "country_of_birth_option_FM": "ميكرونيزيا، ولايات ميكرون",
  "country_of_birth_option_MD": "جمهورية مولدوفا",
  "country_of_birth_option_MC": "موناكو",
  "country_of_birth_option_MN": "منغوليا",
  "country_of_birth_option_MS": "مونتسيرات",
  "country_of_birth_option_MA": "المغرب",
  "country_of_birth_option_MZ": "موزمبيق",
  "country_of_birth_option_MM": "ميانمار",
  "country_of_birth_option_NA": "ناميبيا",
  "country_of_birth_option_NR": "ناورو",
  "country_of_birth_option_NP": "نيبال",
  "country_of_birth_option_NL": "هولندا",
  "country_of_birth_option_AN": "جزر الأنتيل الهولندية",
  "country_of_birth_option_NC": "كاليدونيا الجديدة",
  "country_of_birth_option_NZ": "نيوزيلاندا",
  "country_of_birth_option_NI": "نيكاراغوا",
  "country_of_birth_option_NE": "النيجر",
  "country_of_birth_option_NG": "نيجيريا",
  "country_of_birth_option_NU": "NIUE",
  "country_of_birth_option_NF": "جزيرة نورفولك",
  "country_of_birth_option_MP": "جزر مريانا الشمالية",
  "country_of_birth_option_NO": "النرويج",
  "country_of_birth_option_OM": "سلطنة عمان",
  "country_of_birth_option_PK": "باكستان",
  "country_of_birth_option_PW": "بالاو",
  "country_of_birth_option_PS": "الأراضي الفلسطينية المحتلة",
  "country_of_birth_option_PA": "بنما",
  "country_of_birth_option_PG": "بابوا غينيا الجديدة",
  "country_of_birth_option_PY": "باراجواي",
  "country_of_birth_option_PE": "بيرو",
  "country_of_birth_option_PH": "فيلبيني",
  "country_of_birth_option_PN": "بيتكيرن",
  "country_of_birth_option_PL": "بولندا",
  "country_of_birth_option_PT": "البرتغال",
  "country_of_birth_option_PR": "بويرتو ريكو",
  "country_of_birth_option_QA": "دولة قطر",
  "country_of_birth_option_RE": "جمع شمل",
  "country_of_birth_option_RO": "رومانيا",
  "country_of_birth_option_RU": "الروسية",
  "country_of_birth_option_RW": "رواندا",
  "country_of_birth_option_SH": "سانت هيلانة",
  "country_of_birth_option_KN": "سانت كيتس ونيفيس",
  "country_of_birth_option_LC": "القديسة لوسيا",
  "country_of_birth_option_PM": "سانت بيير وميكلون",
  "country_of_birth_option_VC": "سانت فنسنت وجزر غرينادين",
  "country_of_birth_option_WS": "ساموا",
  "country_of_birth_option_SM": "سان مارينو",
  "country_of_birth_option_ST": "ساو تومي وبرينسيبي",
  "country_of_birth_option_SA": "المملكة العربية السعودية",
  "country_of_birth_option_SN": "السنغال",
  "country_of_birth_option_CS": "صربيا والجبل الأسود",
  "country_of_birth_option_SC": "سيشيل",
  "country_of_birth_option_SL": "سيرا ليون",
  "country_of_birth_option_SG": "سنغافورة",
  "country_of_birth_option_SK": "سلوفاكيا",
  "country_of_birth_option_SI": "سلوفينيا",
  "country_of_birth_option_SB": "جزر سليمان",
  "country_of_birth_option_SO": "الصومال",
  "country_of_birth_option_ZA": "جنوب أفريقيا",
  "country_of_birth_option_GS": "جورجيا الجنوبية وجزر ساندويتش الجنوبية",
  "country_of_birth_option_ES": "إسبانيا",
  "country_of_birth_option_LK": "سيريلانكا",
  "country_of_birth_option_SD": "السودان",
  "country_of_birth_option_SR": "سورينام",
  "country_of_birth_option_SJ": "سفالبارد وجان ماين",
  "country_of_birth_option_SZ": "سوازيلاند",
  "country_of_birth_option_SE": "السويد",
  "country_of_birth_option_CH": "سويسرا",
  "country_of_birth_option_SY": "الجمهورية العربية السورية",
  "country_of_birth_option_TW": "تايوان، مقاطعة الصين",
  "country_of_birth_option_TJ": "طاجيكستان",
  "country_of_birth_option_TZ": "تنزانيا، جمهورية المملكة المتحدة",
  "country_of_birth_option_TH": "تايلاند",
  "country_of_birth_option_TL": "تيمور - ليشتي",
  "country_of_birth_option_TG": "توجو",
  "country_of_birth_option_TK": "Tokelau.",
  "country_of_birth_option_TO": "تونغا",
  "country_of_birth_option_TT": "ترينداد وتوباغو",
  "country_of_birth_option_TN": "تونس",
  "country_of_birth_option_TR": "ديك رومى",
  "country_of_birth_option_TM": "تركمانستان",
  "country_of_birth_option_TC": "جزر تركس وكايكوس",
  "country_of_birth_option_TV": "توفالو",
  "country_of_birth_option_UG": "أوغندا",
  "country_of_birth_option_UA": "أوكرانيا",
  "country_of_birth_option_AE": "الإمارات العربية المتحدة",
  "country_of_birth_option_GB": "المملكة المتحدة",
  "country_of_birth_option_US": "الولايات المتحدة",
  "country_of_birth_option_UM": "جزر الولايات المتحدة البعيدة الصغرى",
  "country_of_birth_option_UY": "أوروجواي",
  "country_of_birth_option_UZ": "أوزبكستان",
  "country_of_birth_option_VU": "فانواتو",
  "country_of_birth_option_VE": "فنزويلا",
  "country_of_birth_option_VN": "فييت نام",
  "country_of_birth_option_VG": "جزر العذراء البريطانية",
  "country_of_birth_option_VI": "جزر فيرجن، الولايات المتحدة",
  "country_of_birth_option_WF": "واليس وفوتونا",
  "country_of_birth_option_EH": "الصحراء الغربية",
  "country_of_birth_option_YE": "اليمن",
  "country_of_birth_option_ZM": "زامبيا",
  "country_of_birth_option_ZW": "زيمبابوي",
  "gender_option_female": "أنثى",
  "gender_option_male": "ذكر",
  "gender_option_nonconf": "جنس غير مطابق",
  "relationship_status_option_single": "غير متزوج",
  "relationship_status_option_domestic_partner": "الشريك المحلي",
  "relationship_status_option_common_law": "القانون العام",
  "relationship_status_option_emancipated_minor": "الطاصف المحررة",
  "relationship_status_option_married": "زوجت",
  "relationship_status_option_divorced": "مُطلّق",
  "relationship_status_option_separated": "منفصل",
  "relationship_status_option_widowed": "الأرامل",
  "housing_option_own": "ملك",
  "housing_option_room_in_apartment": "غرفة في شقة",
  "housing_option_friends_or_family": "أصدقاء أو عائلة",
  "housing_option_regular_rent": "الإيجار المنتظم",
  "housing_option_subsidized_rent": "الإيجار المدعوم",
  "housing_option_shelter": "مَأوىً",
  "housing_option_homeless": "بلا مأوى",
  "employment_option_full_time": "وقت كامل",
  "employment_option_part_time": "دوام جزئى",
  "employment_option_unemployed": "عاطلين عن العمل",
  "education_option_no_high_school": "لا مدرسة ثانوية",
  "education_option_high_school_diploma": "شهادة الدراسة الثانوية",
  "education_option_ged": "جرد",
  "education_option_associate_or_bachelo": "معاون أو درجة البكالوريوس",
  "education_option_post_graduate": "الدراسات العليا",
  "ethnicity_option_two_or_more_races": "اثنان أو كثير أجناس",
  "ethnicity_option_black": "أسود (غير من أصل اسباني)",
  "ethnicity_option_white": "أبيض (غير من أصل اسباني)",
  "ethnicity_option_hispanic_or_latino": "هسبانيون أو لاتينيون",
  "ethnicity_option_asian_or_pacific": "آسيوي أو جزر المحيط الهادئ",
  "ethnicity_option_american_indian_or_alaskan": "الهندي الأمريكي أو ألاسكا",
  "ethnicity_option_other": "آخر",
  "snap_benefits": "برنامج مساعدة التغذية التكميلية",
  "wic_benefits": "برنامج التغذية التكميلية للنساء والرضع والأطفال",
  "tanf_benefits": "مساعدة مؤقتة للعائلات المحتاجة",
  "medicaid_benefits": "التأمين الصحي العام للأشخاص ذوي الدخل المنخفض",
  "ssi_benefits": "برنامج دخل الأمن التكميلي",
  "free_reduced_meals": "برنامج وجبة مخفضة أو مخفضة",
  "tefap_form": "شهادة Tefap.",
  "tefap_form_expired": "انتهت صلاحية شهادة Tefap الخاصة بك",
  "tefap_form_usda_title": "بيان عدم التمييز الصادر عن وزارة الزراعة الأمريكية",
  "tefap_form_usda_subheader": "يرجى العلم بما يلي",
  "tefap_form_usda_body": "<p>In accordance with Federal civil rights law and U.S. Department of Agriculture (USDA) civil rights regulations and policies, the USDA, its Agencies, offices, and employees, and institutions participating in or administering USDA programs are prohibited from discriminating based on race, color, national origin, religion, sex, disability, age, marital status, family/parental status, income derived from a public assistance program, political beliefs, or reprisal or retaliation for prior civil rights activity, in any program or activity conducted or funded by USDA (not all bases apply to all programs). Remedies and complaint filing deadlines vary by program or incident.</p><p>Persons with disabilities who require alternative means of communication for program information (e.g., Braille, large print, audiotape, American Sign Language, etc.) should contact the State or local Agency that administers the program or contact USDA through the Telecommunications Relay Service at 711 (voice and TTY). Additionally, program information may be made available in languages other than English.</p><p>To file a program discrimination complaint, complete the USDA Program Discrimination Complaint Form, AD-3027, found online at <a href=\"https://www.usda.gov/oascr/how-to-file-a-program-discrimination-complaint\">How to File a Program Discrimination Complaint</a> and at any USDA office or write a letter addressed to USDA and provide in the letter all of the information requested in the form. To request a copy of the complaint form, call (866) 632-9992. Submit your completed form or letter to USDA by:</p><p>(1) mail: U.S. Department of Agriculture, Office of the Assistant Secretary for Civil Rights, 1400 Independence Avenue, SW, Mail Stop 9410, Washington, D.C. 20250-9410;</p><p>(2) fax: (202) 690-7442; or</p><p>(3) email: <a href=\"mailto:program.intake@usda.gov\">program.intake@usda.gov</a>.</p><p>USDA is an equal opportunity provider, employer, and lender.</p>",
  "app_button_next": "التالي",
  "app_button_back": "خلف",
  "app_button_submit": "إرسال",
  "app_button_close": "يغلق",
  "app_button_done": "تم",
  "form_required": "مطلوب *",
  "benefits": "برامج الاستحقاقات",
  "benefits_extra": "تفاصيل حول برامج المنافع",
  "help_and_support": "نحن هنا للمساعدة",
  "help_and_support_extra": "الأسئلة الشائعة ومعلومات الاتصال",
  "frequently_asked_questions": "الأسئلة المتكررة",
  "contact_support": "الاتصال بالدعم المتعدد",
  "optional_details": "التفاصيل الاختيارية",
  "address_street_1": "عنوان",
  "address_street_2": "ملائم",
  "city": "مدينة",
  "state": "حالة",
  "zipcode": "رمز بريدي",
  "additional_optional_details": "تفاصيل اضافية",
  "gender": "جنس",
  "relationship_status": "الحالة الاجتماعية",
  "ethnicity": "الأصل العرقي",
  "country_of_birth": "بلد الميلاد",
  "employment": "توظيف",
  "highest_education_obtained": "تعليم",
  "food_preferences": "أذواقهم الغذائية",
  "housing_details": "تفاصيل السكن",
  "housing_status": "وضع الإسكان",
  "special_circumstances": "ظروف خاصة",
  "needs_assistance": "أحتاج إلى مساعدة في المخازن",
  "dont_need_assistance": "أنا لا أحتاج إلى مساعدة في المخازن",
  "aiq_validation_error_min_adult_family_members": "يجب أن يكون عدد أفراد الأسرة البالغين أكبر من 0",
  "aiq_validation_error_max_adult_family_members": "لا يمكن أن يزيد عدد أفراد الأسرة البالغين عن 10",
  "aiq_validation_error_min_child_family_members": "يجب أن يكون عدد أفراد الأسرة من الأطفال أكبر من 0",
  "aiq_validation_error_max_child_family_members": "لا يمكن أن يكون عدد أفراد الأسرة من الأطفال أكبر من 10",
  "aiq_validation_error_min_senior_family_members": "يجب أن يكون عدد كبار السن في الأسرة أكبر من 0",
  "aiq_validation_error_max_senior_family_members": "لا يمكن أن يزيد عدد كبار السن في الأسرة عن 10",
  "aiq_validation_error_required_emergency_contact": "معلومات الاتصال للطوارئ مطلوبة",
  "aiq_validation_error_required_pick_up_name": "اختر معلومات اسم الممثل مطلوبة",
  "aiq_validation_error_required_birth_date": "معلومات تاريخ الميلاد مطلوبة",
  "aiq_validation_error_regex_zip_code": "الرمز البريدي يجب أن يكون رقمي",
  "aiq_validation_error_required_first_name": "الاسم الأول مطلوب",
  "aiq_validation_error_required_last_name": "اسم العائلة مطلوب",
  "aiq_validation_error_min_baby_supplies": "مؤن الأطفال يجب أن تكون أكبر من 0",
  "aiq_validation_error_max_baby_supplies": "لوازم الأطفال لا يمكن أن تكون أكبر من 10",
  "dietary_preferences_option_lactose": "عدم تحمل اللاكتوز",
  "dietary_preferences_option_gluten": "حساسية القمح",
  "dietary_preferences_option_kosher": "كوشير",
  "dietary_preferences_option_halal": "حلال",
  "dietary_preferences_option_dairy_free": "الألبان مجانا",
  "dietary_preferences_option_vegetarian": "نباتي",
  "dietary_preferences_option_vegan": "نباتي",
  "dietary_preferences_option_fodmap": "fodmap.",
  "dietary_preferences_option_nut_allergy": "شجرة الجوز والفول السوداني الحساسية",
  "dietary_preferences_option_fish_allergy": "حساسية الأسماك والمحافظة",
  "dietary_preferences_option_none": "لا تفضيلات",
  "tefap_additional_info_requested": "معلومات إضافية المطلوبة",
  "tefap_zipcode_correct": "هل الرمز البريدي الخاص بك صحيح؟",
  "tefap_address_correct": "هل عنوانك صحيح؟",
  "tefap_participate_in_programs": "هل يشارك أي شخص في أسرتك في أي من البرامج التالية؟ ",
  "tefap_check_all_that_apply": "يرجى اختيار كل ما ينطبق. إذا لم يكن هناك أي منها، فانقر فوق التالي لمزيد من الخيارات.",
  "tefap_household_numbers_correct": "هل عدد الأشخاص في أسرتك صحيحة؟",
  "tefap_household_dont_include_yourself": "من فضلك لا تضع نفسك على هذه الشاشة. يتطلب TEFAP فقط الحجم الإجمالي لأسرتك، ولكن Plentiful يعرض المعلومات التي قدمتها مسبقًا.",
  "tefap_income_at_or_below_question": "هو دخلك في أو أدناه",
  "tefap_for_household_size": "لأسرتك",
  "tefap_retake_attestation": "هل ترغب في إعادة النظر في التصديق؟",
  "tefap_attestation_completed": "لقد أكملت بنجاح نموذج شهادة Tefap.",
  "tefap_thank_you": "شكرًا لك!",
  "tefap_is_recorded": "تم تسجيل شهادة Tefap الخاصة بك. يمكنك إعادة استخدامها في ملفك الشخصي.",
  "tefap_sign_below": "اسمك إختياري)",
  "tefap_legal_signing": "من خلال التوقيع أدناه، أعلن أن دخلي من جميع المصادر لا يتجاوز الدخل المذكور أعلاه بالنسبة للأسر التي تحمل نفس العدد من الناس كأسرتي أو أن أسرتي تشارك في البرنامج (البرامج) التي قمت بتسجيلها في هذا النموذج. أفهم أن هذه السجلات ستعقد بثقة في موقع التوزيع هذا ولكن قد يتم إطلاق سراحه إلى مكتب ولاية نيويورك للخدمات العامة أو وزارة الزراعة الأمريكية للمراجعة بناء على طلبها.",
  "tefap_retake": "استعادة",
  "program_complete_now": "أكمل الآن",
  "program_complete_later": "كاملة في وقت لاحق",
  "reservation_confirmed": "زيارة أكد",
  "tefap_reservation_confirmed": "تم تأكيد زيارتك!",
  "pre_registration_confirmed": "زيارة أكد",
  "your_upcoming_reservation": "زيارتك القادمة",
  "your_upcoming_pre_registration": "زيارتك القادمة",
  "tefap_attestation_needed": "يطلب هذا المخزن شهادة Tefap الخاصة بك.",
  "tefap_attestation_complete_now": "أكملها الآن وتوفير الوقت في زيارة المخزن التالية.",
  "tefap_description": "من خلال برنامج المساعدة الغذائية الطارئة (TEFAP)، توفر وزارة الزراعة الأمريكية الدعم الغذائي لمجتمعك المحلي، مما يجعله متاحًا لك من خلال الوكالات المجتمعية مثل مطابخ الحساء ومخازن الطعام.",
  "tefap_what_is_tefap": "ما هو tefap؟",
  "tefap_confirm_share_with_pantry": "يرجى تأكيد أنك تريد مشاركة المعلومات التالية مع هذا المخزن.",
  "tefap_thanks_for_sharing": "شكرا لك على توفير المعلومات الإضافية التي طلبها المخزن!",
  "tefap_continue_make_reservation": "متابعة جدولة الزيارة",
  "tefap_pantry_is_requesting": "هذا المخزن يطلب",
  "tefap_missing_information": "معلومات مفقودة",
  "tefap_pantry_will_ask": "انقر على \"التالي\" لإضافة هذه المعلومات الآن. إذا تخطيتها، سيطلبها المخزن في زيارتك القادمة.",
  "tefap_submission_pending": "أرسل إجاباتك إلى المخزن...",
  "cancel_edit": "إلغاء تحرير",
  "edit": "تعديل",
  "select": "يختار",
  "can_prepare_food": "يمكن إعداد الطعام",
  "cannot_prepare_food": "لا يمكن إعداد الطعام",
  "pantry_details_prompt_title": "{{programName}} مطلوب",
  "pantry_details_prompt_without_visit_label": "هذا المخزن يستخدم {{programName}} للتسجيل. سيكون لديك أسئلة إضافية لتجيب عليها عندما تصل إلى المخزن.",
  "pantry_details_prompt_visit_label": "هذا المخزن يستخدم {{programName}} للتسجيل. وفر الوقت في زيارتك القادمة من خلال الإجابة على هذه الأسئلة عبر الإنترنت.",
  "state_program_attestation_cannot_complete": "نأسف، لكننا غير قادرين على إكمال شهادتك في هذا الوقت. يمكنك المحاولة مرة أخرى لاحقاً، أو الاتصال بالدعم، أو إكمال هذا عند وصولك إلى المخزن.",
  "state_program_attestation_submitted": "شكراً لك على إكمال شهادة {{programName}}! تم إرسال إجاباتك بنجاح إلى المخزن. هذه هي نهاية أسئلة {{programName}}، وأي مطالبات أخرى تأتي من برامج Plentiful الأخرى.",
  "state_program_cancel_confirmation": "هل أنت متأكد أنك تريد إلغاء شهادتك لـ {{programName}}؟ قد تحتاج إلى الإجابة على هذه الأسئلة عند زيارة المخزن.",
  "state_program_cancel_attestation": "إلغاء الشهادة",
  "state_program_resume_attestation": "استئناف الشهادة",
  "tefap_no_submit": "لا، يقدم",
  "tefap_yes_retake": "نعم، استعادة",
  "tefap_expires": "تنتهي صلاحيته",
  "tefap_incomplete": "غير مكتمل، أكمله الآن لتوفير الوقت في زيارتك القادمة للمخزن",
  "tefap_none": "لا أحد",
  "tefap_benefit_programs_select": "حدد التسجيل الخاص بك في البرامج التالية",
  "tefap_pantry_requests_info": "يطلب هذا المخزن معلومات إضافية لزيارتك القادمة.",
  "tefap_eligible": "أنت مؤهل",
  "tefap_not_eligible": "لم تكن مؤهلة",
  "tefap_receive_product": "لتلقي منتج tefap",
  "tefap_eligible_program": "تشارك في البرنامج التالي",
  "tefap_eligible_programs": "تشارك في البرامج التالية",
  "tefap_not_eligible_program": "أنت لا تشارك في أي برامج",
  "tefap_household_income": "دخل منزلك ل",
  "tefap_info_changed": "هل تغيرت معلومات أهلية TEFAP (المشاركة في برامج المنافع، حجم الأسرة و / أو الدخل) مؤخرا؟",
  "tefap_still_get_food": "لا يزال بإمكانك الحصول على الطعام غير TEFAP من البندقية.",
  "tefap_form_checking_here": "عن طريق التحقق من هنا، أنت تشهد أن ما يلي صحيح:",
  "tefap_form_checking_1": "1. اسم المستلم وعنوانه وحجم الأسرة المذكورة أعلاه صحيحة.",
  "tefap_form_checking_2_CO": "2. المستلم يقيم في كولورادو (لا يوجد حد أدنى للإقامة المطلوبة).",
  "tefap_form_checking_2_NY": "2. يقيم المستلم داخل ولاية نيويورك (لا يوجد الحد الأدنى من الإقامة المطلوبة).",
  "tefap_form_checking_3": "3. يلتقي المستلم الخيار 1 و / أو الخيار 2 من إرشادات الأهلية Tefap أعلاه.",
  "tefap_form_checking_4": "4. هذا الطعام هو لاستهلاك المنازل للمستلم فقط، ولن يتم بيعها أو تداولها أو مقبولة.",
  "tefap_form_checking_5_1": "5. المستلم يدرك حقوقهم المدنية كما هو موضح في",
  "tefap_form_checking_5_2": "بيان عدم اتساع وزارة الزراعة الأمريكية.",
  "tefap_out_of_state": "أنت تعيش في دولة مختلفة",
  "and": "و",
  "or": "أو",
  "exceeds": "ليس أدناه",
  "not_exceeds": "لا يتجاوز",
  "people": "اشخاص",
  "person": "شخص",
  "because": "لان",
  "custom_field_first_name": "الاسم الأول",
  "custom_field_last_name": "الكنية",
  "custom_field_contact_info": "معلومات الاتصال",
  "custom_field_birth_date": "عيد الميلاد",
  "custom_field_zip_code": "رمز بريدي",
  "custom_field_household_size": "حجم حجاب",
  "custom_field_food_pickup": "ممثل بيك اب",
  "custom_field_emergency_contact": "الاتصال بالطوارىء",
  "custom_field_address": "عنوان",
  "custom_field_needs_assistance": "ظروف خاصة (مساعدة المساعدة)",
  "custom_field_benefits_programs": "برامج الفوائد",
  "custom_field_tefap_income_eligibility": "أهلية دخل Tefap",
  "custom_field_relationship_status": "الحالة الاجتماعية",
  "custom_field_ethnicity": "الأصل العرقي",
  "custom_field_education": "أعلى التعليم الذي تم الحصول عليه",
  "custom_field_dietary_preferences": "التفضيلات الغذائية",
  "custom_field_gender": "جنس",
  "custom_field_country_of_birth": "بلد الميلاد",
  "custom_field_employment": "توظيف",
  "custom_field_food_preparation": "يمكن إعداد الطعام",
  "custom_field_housing": "وضع الإسكان",
  "search": "بحث (اسم المخزن، الرمز البريدي، المدينة، الولاية)",
  "all": "الكل",
  "pantry_filter_program_type": "نوع البرنامج",
  "pantry_filter_program_type_non-food": "غير الغذائية",
  "pantry_filter_program_type_foodpantry": "مخزن المواد الغذائية (البقالة المجانية)",
  "pantry_filter_program_type_soupkitchen": "مطبخ الحساء (وجبات ساخنة مجانية)",
  "pantry_filter_status": "حالة",
  "pantry_filter_status_all": "الجميع",
  "pantry_filter_status_opennow": "مفتوح الان",
  "pantry_filter_status_opentoday": "مفتوح اليوم",
  "pantry_filter_status_openthisweek": "افتح هذا الأسبوع",
  "pantry_filter_status_other": "آخر",
  "pantry_filter_pantry_type": "نوع المخزن",
  "pantry_filter_pantry_type_plentifulpantry": "مخزن وفيرة",
  "pantry_filter_pantry_type_verifiedpartnerpantry": "مخزن الشريك الذي تم التحقق منه",
  "pantry_filter_pantry_type_unverifiedpartnerpantry": "مخزن الشريك الذي لم يتم التحقق منه",
  "search_no_results_found": "لم يتم العثور على نتائج",
  "search_no_pantries_match": "لا توجد مخازن تطابق \"{query}\"",
  "search_try_searching_by": "حاول البحث عن طريق:",
  "search_suggestion_city": "اسم المدينة (على سبيل المثال، \"بروكلين\")",
  "search_suggestion_city_accessibility": "اسم المدينة، على سبيل المثال، بروكلين",
  "search_suggestion_zipcode": "الرمز البريدي (على سبيل المثال، \"10001\")",
  "search_suggestion_zipcode_accessibility": "الرمز البريدي، على سبيل المثال، 10001",
  "search_suggestion_pantry_name": "اسم المخزن",
  "search_suggestion_street_address": "عنوان الشارع",
  "search_accessibility_no_results": "لم يتم العثور على نتائج لـ {query}. حاول البحث حسب اسم المدينة أو الرمز البريدي أو اسم المخزن أو عنوان الشارع.",
  "search_accessibility_no_results_generic": "لم يتم العثور على نتائج. حاول البحث حسب اسم المدينة أو الرمز البريدي أو اسم المخزن أو عنوان الشارع.",
  "search_accessibility_no_results_sites": "لم يتم العثور على نتائج لـ {query}. حاول البحث حسب اسم المخزن أو المدينة.",
  "search_accessibility_no_results_sites_generic": "لم يتم العثور على نتائج. حاول البحث حسب اسم المخزن أو المدينة.",
  "search_error_unable_to_display": "غير قادر على عرض نتائج البحث",
  "search_error_occurred": "حدث خطأ أثناء عرض نتائج البحث. يرجى المحاولة مرة أخرى.",
  "search_results_truncated": "عرض أفضل النتائج. جرّب بحثاً مختلفاً إذا لم تجد ما تبحث عنه.",
  "accessibility_phone": "الهاتف: {phone}",
  "accessibility_email": "البريد الإلكتروني: {email}",
  "accessibility_website": "الموقع الإلكتروني: {website}",
  "pantry_filter_service_type": "نوع الخدمة",
  "pantry_filter_service_type_line": "على أساس الخط",
  "pantry_filter_service_type_pre-registration": "التسجيل المسبق",
  "pantry_filter_service_type_qr-code": "تسجيل الوصول إلى رمز الاستجابة السريعة",
  "pantry_filter_service_type_reservation": "حجز",
  "program_type_benefit_enrollment": "استحقاق الالتحاق",
  "program_type_emergency_services": "خدمات الطوارئ",
  "program_type_non_plentiful_pantry": "مخزن غير رائع",
  "program_type_other_services": "خدمات أخرى",
  "program_type_plentiful_pantry": "مخزن وفيرة",
  "program_type_shelter": "مَأوىً",
  "program_type_soup_kitchen": "مطعم للفقراء",
  "service_restriction_none": "لا قيود",
  "service_restriction_seniors": "كبار السن فقط",
  "service_restriction_families_with_children": "العائلات التي لديها أطفال فقط",
  "service_restriction_new_clients": "عملاء جدد فقط",
  "service_restriction_existing_clients": "العملاء الحاليين فقط",
  "filter_by_category": "تصفية حسب الفئة",
  "opted_out": "يبدو أن رقم هاتفك تم اختياره من الرسائل القصيرة ، لذلك لا يمكننا إرسال رمز تسجيل الدخول إليك. يرجى الاشتراك مرة أخرى عن طريق الرسائل النصية START إلى 726879 ثم حاول مرة أخرى",
  "miles_away_singular": "على بعد ميل واحد",
  "miles_away_plural": "على بعد %s أميال",
  "today": "اليوم",
  "address_autocomplete_placeholder": "ابدأ الكتابة لرؤية الاقتراحات",
  "push_notification_permissions_denied": "لم يتم منح الأذونات اللازمة لإرسال الإشعارات الفورية. يرجى فتح إعدادات النظام وتمكين إرسال الإشعارات الفورية.",
  "push_notification_setup_error": "حدث خطأ أثناء إعداد إشعارات الدفع.",
  "push_notification_alternate_notifications": "سوف تستمر في تلقي الإشعارات عبر الرسائل القصيرة أو البريد الإلكتروني.",
  "loading_message": "البحث عن مخازن الطعام بالقرب منك",
  "location_services_no_access": "يبدو أن تطبيق Plentiful لا يستطيع الوصول إلى موقع جهازك. يُرجى تفعيل خدمة الموقع لتطبيق Plentiful في إعدادات المتصفح أو الجهاز.",
  "error_screen_header": "عفواً! حدث خطأ ما.",
  "error_screen_message": "واجهنا مشكلة غير متوقعة. يمكنك محاولة إعادة تشغيل التطبيق أو التواصل مع الدعم.",
  "update_available_header": "يتوفر تحديث",
  "update_available_message": "أعد التشغيل لتحميل أحدث إصدار.",
  "restart_app": "إعادة تشغيل التطبيق",
  "email_support": "دعم البريد الإلكتروني",
  "map_zoom_to_see_all": "قم بالتكبير لرؤية جميع المواقع",
  "program_eligible": "أنت مؤهل لبرنامج {{program}}.",
  "program_ineligible": "أنت غير مؤهل لبرنامج {{program}}: {{reason}}",
  "program_not_applicable": "لقد أكملت {{program}}.",
  "program_completed": "لقد أكملت جميع أسئلة {{program}}.",
  "program_unknown_eligibility": "شكراً لك على إكمال النموذج. سيقوم مزود الخدمة بتحديد أهليتك عند وصولك.",
  "site_map_error_title": "حدث خطأ ما",
  "site_map_error_message": "تعذر تحميل الخريطة. يرجى المحاولة مرة أخرى.",
  "site_map_load_error_title": "تعذر تحميل المواقع",
  "site_map_load_error_message": "حدث خطأ أثناء تحميل هذه المنطقة. يرجى المحاولة مرة أخرى.",
  "site_map_retry": "إعادة المحاولة",
  "site_list_search_placeholder": "Search pantry name, ZIP, city",
  "site_list_result_count": "{{count}} أماكن",
  "site_list_result_count_one": "{{count}} مكان",
  "site_list_result_count_zero": "لم يتم العثور على أي أماكن",
  "site_list_today": "Today",
  "site_list_tomorrow": "Tomorrow",
  "site_list_status_open_until": "Open now until {{time}}",
  "site_list_status_open_now": "مفتوح الآن",
  "site_list_status_closed_next_open": "Closed now · next open {{day}} {{time}}",
  "site_list_status_no_upcoming": "No upcoming services",
  "site_list_status_more_available": "قد تتوفر أوقات إضافية · تواصل مع مخزن الطعام",
  "site_list_booking_walkin": "Walk in",
  "site_list_booking_reservation": "Reservation",
  "site_list_booking_preregistration": "Pre-registration",
  "site_list_booking_unknown": "غير معروف",
  "site_list_more_times": "+ more times available",
  "site_list_default_event_name": "Food Distribution",
  "site_list_unconfirmed_title": "Hours not confirmed",
  "site_list_unconfirmed_body": "We list this place from a partner directory but don't have its current times. Call before you go.",
  "site_list_timezone_note": "الأوقات معروضة بتوقيت {{zone}}",
  "site_details_upcoming_events_heading": "الخدمات القادمة",
  "site_details_reserve_cta": "حجز موعد",
  "site_details_plan_visit_cta": "خطط لزيارتك",
  "site_details_no_upcoming_events": "لا توجد خدمات قادمة",
  "site_details_timezone_note": "الأوقات معروضة بتوقيت {{zone}}",
  "site_details_more_windows": "+ مواعيد إضافية متاحة",
  "site_details_event_name_fallback": "توزيع",
  "site_details_slot_picker_no_times": "لا توجد أوقات متاحة",
  "site_details_slot_full": "ممتلئ",
  "site_details_availability_as_of": "التوفر اعتبارًا من {{time}}",
  "site_details_availability_error": "تعذر تحميل الأوقات. يرجى المحاولة مرة أخرى."
}
